import { makeStyles } from '@material-ui/core';
import { ReactComponent as NotSort } from '../../static/images/not-sort.svg';
import { ReactComponent as AscSort } from '../../static/images/asc-sort.svg';
import { ReactComponent as DescSort } from '../../static/images/desc-sort.svg';

const useStyles = makeStyles(() => ({
  sortImg: {
    width: '1.5rem',
    height: '1.5rem',
  },
}));

const Sort = ({ sort, sortKey }) => {
  const classes = useStyles;

  if (sort.sortKey === sortKey) {
    return sort.sortOrder === 'asc' ? (
      <AscSort className={classes.sortImg} />
    ) : (
      <DescSort className={classes.sortImg} />
    );
  } else {
    return <NotSort className={classes.sortImg} />;
  }
};

export default Sort;
